import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";

const Main = lazy(() => import("../../components/transactions/outstandingPayment/main"));

const OutstandingPayment = () => {
  return (
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>
  );
};

export default OutstandingPayment;

